import { Button } from 'antd';

import {
    PPA_AXIS_CONFIG_MODAL_APPLY_BTN,
    PPA_AXIS_CONFIG_MODAL_CANCEL_BTN,
    PPA_AXIS_CONFIG_MODAL_RESET_BTN,
} from 'constants/ppaTestIds';

type AxisConfigurationModalFooterProps = {
    hasApplyChanges: boolean;
    hasResetChanges: boolean;
    onReset: () => void;
    onCancel: () => void;
    onApply: () => void;
};

const AxisConfigurationModalFooter = ({
    hasApplyChanges,
    hasResetChanges,
    onReset,
    onCancel,
    onApply,
}: AxisConfigurationModalFooterProps) => (
    <div className="flex items-center justify-between">
        <Button
            type="link"
            className="!h-8 !p-0 !font-normal !text-blackAlt hover:!text-blackAlt disabled:!text-fontGreyAlt1"
            onClick={onReset}
            disabled={!hasResetChanges}
            data-testid={PPA_AXIS_CONFIG_MODAL_RESET_BTN}
        >
            Reset
        </Button>
        <div className="flex items-center gap-2">
            <Button
                className="!h-8 !rounded-lg !border-borderGreyAl1 !font-semibold"
                onClick={onCancel}
                data-testid={PPA_AXIS_CONFIG_MODAL_CANCEL_BTN}
            >
                Cancel
            </Button>
            <Button
                type="primary"
                className="axis-apply-btn !h-8 !rounded-lg !font-normal"
                onClick={onApply}
                disabled={!hasApplyChanges}
                data-testid={PPA_AXIS_CONFIG_MODAL_APPLY_BTN}
            >
                Apply
            </Button>
        </div>
    </div>
);

export default AxisConfigurationModalFooter;
